<template>
  <SvoiSelect
    v-bind="$props"
    :options="options"
    :internal-search="false"
    :loading="loading"
    @input="val => $emit('input', val)"
    @update:model-value="val => $emit('update:modelValue', val)"
    @blur="$emit('blur')"
    @search-change="debouncedSearchChange"
  >
    <template v-for="(_, slot) of $slots" #[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>
    <template #no-options>
      <slot name="no-options">Список пуст, введите строку для поиска</slot>
    </template>
  </SvoiSelect>
</template>

<script lang="ts">
import { defineComponent, PropType, ref, computed, watch } from 'vue-demi'
import { SearchCallback, OptionsSelect } from '@svoi-ui/interfaces/select'
import { debounce } from '@svoi-ui/shared/utils/decorators'
import { SvoiSelect } from '.'

export default defineComponent({
  name: 'SvoiAsyncSelect',
  components: { SvoiSelect },
  props: {
    ...SvoiSelect.props,
    searchCallback: {
      type: Function as PropType<SearchCallback>,
      required: true
    },
    delay: {
      type: Number,
      default: 0
    },
    initialOptions: {
      type: Array as PropType<OptionsSelect>,
      default: () => []
    }
  },
  emits: ['input', 'blur', 'update:modelValue'],
  setup(props) {
    const options = ref<OptionsSelect>([])
    const loading = ref(false)

    watch(
      () => props.initialOptions,
      value => {
        options.value = value
      },
      { immediate: true }
    )

    const onSearchChange = (query: string) => {
      if (query) {
        loading.value = true
        props
          .searchCallback(query)
          .then(data => {
            options.value = data
          })
          .finally(() => {
            loading.value = false
          })
      }
    }

    const debouncedSearchChange = computed(() =>
      props.delay > 0 ? debounce(onSearchChange, props.delay) : onSearchChange
    )

    return { options, loading, debouncedSearchChange }
  }
})
</script>
